import React, { useEffect } from 'react'
import { Modal, Button, Input, Textarea, Flex, Text, Box, SegmentedControl } from '@mantine/core';
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { usePlanStore } from '../../store/usePlanStore';

const ModalPlans = ({ onClose, isOpen, item }) =>
{
  const { postNewPlan, updatePlan, loading } = usePlanStore();

  const formik = useFormik({
    initialValues: initialValues(),
    validationSchema: Yup.object(validationSchema()),
    onSubmit: async (data) =>
    {
      try {
        if (item === null) {
          await postNewPlan(data);
          formik.resetForm()
        } else {
          data._id = item._id;
          await updatePlan(data)
          formik.resetForm()
        }
        onClose()
      } catch (error) {
        console.log(error)
      }
    }
  })

  const close = () =>
  {
    formik.resetForm()
    onClose()
  }

  useEffect(() =>
  {
    if (item) {
      formik.setFieldValue('name', item.name);
      formik.setFieldValue('description', item.description);
      formik.setFieldValue('megas', item.megas);
      formik.setFieldValue('price', item.price);
      formik.setFieldValue('type_contract', item.type_contract || 'Postpago');
    }
  }, [ item ])

  return (
    <>
      <Modal 
        size="lg" 
        opened={ isOpen } 
        onClose={ close } 
        title={ !item?._id ? 'Agregar Nuevo Plan' : 'Editar Plan Existente' } 
        centered
      >
        <Box className="flex flex-col gap-md p-xs">
          
          <Box>
            <Text size="sm" fw={700} mb={5}>Tipo de Contrato</Text>
            <SegmentedControl
              fullWidth
              color="yellow"
              size="md"
              value={formik.values.type_contract}
              onChange={(val) => formik.setFieldValue('type_contract', val)}
              data={[
                { label: 'Postpago', value: 'Postpago' },
                { label: 'Prepago', value: 'Prepago' },
              ]}
            />
          </Box>

          <Input.Wrapper label="Nombre del Plan">
            <Input
              variant="filled"
              size="md"
              placeholder="Ej: Plan Gamer 100MB"
              value={ formik.values.name }
              onChange={ formik.handleChange("name") }
            />
            { formik.touched.name && formik.errors.name && <Text c="red" fz="xs">{ formik.errors.name }</Text> }
          </Input.Wrapper>

          <Input.Wrapper label="Descripción">
            <Textarea 
              placeholder='Breve descripción de los beneficios...'
              variant='filled'
              minRows={3}
              value={ formik.values.description }
              onChange={ (e) => formik.setFieldValue('description', e.target.value) }
            />
            { formik.touched.description && formik.errors.description && <Text c="red" fz="xs">{ formik.errors.description }</Text> }
          </Input.Wrapper>

          <Box className='grid grid-cols-2 gap-md'>
            <Input.Wrapper label="Velocidad (MB)">
              <Input
                variant="filled"
                size="md"
                placeholder="Ej: 100"
                type="number"
                value={ formik.values.megas }
                onChange={ formik.handleChange("megas") }
              />
              { formik.touched.megas && formik.errors.megas && <Text  c="red" fz="xs">{ formik.errors.megas }</Text> }
            </Input.Wrapper>

            <Input.Wrapper label="Precio Mensual">
              <Input
                variant="filled"
                size="md"
                placeholder="Ej: 500"
                type="number"
                value={ formik.values.price }
                onChange={ formik.handleChange("price") }
              />
              { formik.touched.price && formik.errors.price && <Text c="red" fz="xs">{ formik.errors.price }</Text> }
            </Input.Wrapper>
          </Box>
        </Box>

        <Flex justify="flex-end" gap="md" mt="xl" p="xs">
          <Button variant="subtle" color='gray' onClick={ close }>
            Cancelar
          </Button>
          <Button 
            loading={loading}
            onClick={ () => formik.handleSubmit() }
          > 
            { !item?._id ? 'Crear Plan' : 'Guardar Cambios' }
          </Button>
        </Flex>

      </Modal>
    </>
  )
}

export default ModalPlans;

function initialValues ()
{
  return {
    name: '',
    description: '',
    megas: '',
    price: '',
    type_contract: 'Postpago'
  }
}

function validationSchema ()
{
  return {
    name: Yup.string().required('El nombre es requerido'),
    description: Yup.string().required('La descripción es necesaria'),
    megas: Yup.number().required('Ingresa la velocidad en Megas'),
    price: Yup.number().required('Ingresa el precio del abono'),
    type_contract: Yup.string().required('Selecciona el tipo de contrato'),
  }
}
